import { AuthService } from './auth.service';
import { environment } from 'environments/environment';
import { FactoryProvider } from '@angular/core';
import { Configuration } from '@api/client';

let configParams: Configuration | undefined;

export function getApiConfiguration(authService: AuthService) {
  if (!configParams) {
    configParams = new Configuration({
      basePath: environment.apiBasePath,
      accessToken: () => authService.getToken(),
    });
  }

  return configParams;
}

export const apiConfigurationProvider: FactoryProvider = {
  provide: Configuration,
  useFactory: getApiConfiguration,
  deps: [AuthService],
};
